module.exports = __webpack_public_path__ + "img/cloud-sun.6bc270bd.svg";